var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.266 9.648H23.3V9.6H12.5V14.4H19.28C18.29 17.196 15.632 19.2 12.5 19.2C8.522 19.2 5.3 15.978 5.3 12C5.3 8.022 8.522 4.8 12.5 4.8C14.336 4.8 16.004 5.49 17.276 6.624L20.672 3.228C18.53 1.23 15.662 0 12.5 0C5.87 0 0.5 5.37 0.5 12C0.5 18.63 5.87 24 12.5 24C19.13 24 24.5 18.624 24.5 12C24.5 11.196 24.416 10.41 24.266 9.648Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.886 6.414L5.828 9.306C6.896 6.666 9.476 4.8 12.5 4.8C14.336 4.8 16.004 5.49 17.276 6.624L20.672 3.228C18.53 1.23 15.662 0 12.5 0C7.892 0 3.896 2.604 1.886 6.414Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24C15.602 24 18.416 22.812 20.546 20.886L16.832 17.742C15.626 18.654 14.132 19.2 12.5 19.2C9.38001 19.2 6.72801 17.208 5.73201 14.43L1.82001 17.448C3.80601 21.336 7.83801 24 12.5 24Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.266 9.64801H23.3V9.60001H12.5V14.4H19.28C18.806 15.744 17.942 16.902 16.826 17.742L20.54 20.886C20.276 21.126 24.494 18 24.494 12C24.494 11.196 24.41 10.41 24.26 9.64801H24.266Z",
    fill: "#1976D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.778ba524e91d3c60ef4e2a1eee0b7329.svg";
export { ForwardRef as ReactComponent };